import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { AppContext } from "../../context/AppContext";
import searchicon from "../../assets/images/search_icon.svg";
import importicon from "../../assets/images/import.svg";
import exporticon from "../../assets/images/export.svg";

import Pagination from "../../../src/sharedComponent/Pagination";
import { simpleGetCallWithErrorResponse } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import Loader from '../Loader';
import NoData from '../../sharedComponent/NoData';
import { ToastMsg } from '../TostMsg';

function Subscription() {

  const { sidebar, userData, permissions } = useContext(AppContext);

  const [subscriptionList, setSubscriptionList] = useState([])
  const [isLoadin, setIsLoading] = useState(false)
  const [usersPerPage, setUserPerPage] = useState(25)
  const [currentPage, setCurrentPage] = useState(0)
  const [triggerType, setTriggerType] = useState(0)
  const startIndex = currentPage * usersPerPage;
  const endIndex = startIndex + usersPerPage

  const [search, setSearch] = useState('')


  const getSubscriptionList = () => {

    setIsLoading(true)


    simpleGetCallWithErrorResponse(ApiConfig.GET_SUBSCRIPTIONS).then((res) => {

      if (res?.json?.success) {

        setSubscriptionList(res?.json?.data)

      }

      setIsLoading(false)

    })


  }

  const trigerSubs = (id) => {

    setIsLoading(true)

    //let apiCall = triggerType == 2 ? ApiConfig?.NEW_ENTITY_TRIGGER + `${id}/trigger` : ApiConfig.SUBS_TRIGGER + `${id}/${userData?.UserId}`

    simpleGetCallWithErrorResponse(ApiConfig.SUBS_TRIGGER + `${id}/${userData?.UserId}`).then((res) => {


      if (res?.json?.success) {

        ToastMsg('success', res?.json?.message)

        getSubscriptionList()

      } else {

        ToastMsg('error', res?.json?.message)

      }

      setIsLoading(false)

    })

  }

  useEffect(() => {

    getSubscriptionList()

  }, [])


  return (
    <div className=''>

      <div className={sidebar ? "taskMain " : "cx-active taskMain"} id="cx-main">

        <div className="role-content">
          <div className="sub-header-role">
            <h6 className="mt-2 role-text">Workflow Trigger List</h6>
          </div>
          <div className="d-flex justify-content-between role-searchbar-and-btns resposiveheadder">
            <div className="role-table-header reponsivesrc">
              <div className="search-input-wrapper">
                <input type="text" placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <img src={searchicon} alt="" />
              </div>
              <div className="entries-wrapper">
                <p>Entries per page</p>
                <select
                  class="form-select select-drop-icon remove-border"
                  aria-label="Default select example"
                  value={usersPerPage}
                  onChange={(e) => {setUserPerPage(e.target.value)
                    setCurrentPage(0);
                  }}
                >
                  <option selected value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                </select>
              </div>
              <div className="client-wrapper">
                <p>Select Type</p>
                <select
                  class="form-select select-drop-icon remove-border"
                  aria-label="Default select example"
                  value={triggerType}
                  onChange={(e) => {
                    setTriggerType(e.target.value)


                  }}
                >

                  <option value="0">Subscription List</option>
                  <option value="1">New Entity</option>
                </select>
              </div>
            </div>
            {
              permissions && permissions['Export Workflow Trigger List'] &&

              <div className="role-btns-wrapper servicemappingbtnexport">
                {/* hide import icon/share */}
                {/* <button className="import-icon-img">
                  <img src={importicon} alt="" />
                </button> */}
                <button>
                  {" "}
                  <img src={exporticon} alt="" />
                </button>
              </div>
            }
          </div>
          <div className="table-wrapper" id="scrol-tblNtable-wrapper-af">
          {isLoadin ? (<Loader />) : (
            <table>
              <tr>
                <th>Sr. no</th>
                <th>Name</th>
                <th>Id</th>
                {
                  triggerType == 1 && <th>Entity</th>
                }
                {
                  triggerType == 0 && <>
                    <th>Client Name</th>
                    <th>Subscription  Name</th>
                  </>
                }
                {
                  permissions && permissions['Trigger Workflow'] &&
                  <th>Action</th>
                }
              </tr>
              {
           
               subscriptionList.length === 0 ? <NoData /> : subscriptionList.filter((subs) => subs?.entityId == triggerType).filter((subs) => {
                return search ? (subs?.name?.toLowerCase().includes(search.trim().toLowerCase()) ||
                  subs?.workflowName?.toLowerCase().includes(search.trim().toLowerCase())) : subs
              }).slice(startIndex, endIndex).map((subs, index) => {
                return (
                  <tr key={"srnumber" + index} className="table-row-custom">
                    <td>{startIndex + index + 1}</td>
                    <td style={{textWrap:'auto'}}>{subs?.uniqueId}</td>
                    <td>{subs?.id}</td>
                    {
                      triggerType == 1 && <td>{subs?.subscriptionName}</td>
                    }
                    {
                      triggerType == 0 && <><td>{subs?.name}</td>
                        <td>{subs?.subscriptionName}</td>
                      </>
                    }

                    {
                      permissions && permissions['Trigger Workflow'] &&
                      // <td
                      //   onClick={() => trigerSubs(subs?.id)}
                      // >Trigger</td>
                      <td>
                         <button
              // disabled={buttonLoader ? true : false}
             className='btn-trigger'
              onClick={() => trigerSubs(subs?.id)}
            >Trigger</button>
                      </td>
                    }
                    {/* <td
                      className={
                        srnumber.status === "Active"
                          ? "green-active"
                          : "red-deactive"
                      }
                    >
                      {srnumber.status}
                    </td> */}
                  </tr>
                );
              })}
            </table>
          )}
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-12">
            <Pagination
              // data={subscriptionList && subscriptionList?.length > 0 && subscriptionList}
              data={subscriptionList && subscriptionList?.length > 0 && subscriptionList.filter((subs) => subs?.entityId == triggerType)}
              currentPage={currentPage}
              usersPerPage={usersPerPage}
              pageChangeHandler={(selected) => {
                setCurrentPage(selected.selected)
              }}
              searchValue={search}

            />
          </div>
        </div>
      </div>
    </div>

  )
}

export default Subscription;